import {DialogComponent} from "./dialog.component";

export const Dialog = DialogComponent;
